var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,18h4v2H3l-1-1V1L3,0h14l1,1V7h-2V2H4V18ZM14,4H6v2H14v-2ZM6,10h3v-2h-3v2Zm16.29,13.71l-3.76-3.76-.76,.76-.71,.29h-4.14l-.71-.29-2.93-2.93-.29-.71v-4.14l.29-.71,2.93-2.93,.71-.29h4.14l.71,.29,2.93,2.93,.29,.71v4.14l-.29,.71-.76,.76,3.76,3.76-1.41,1.41Zm-3.29-7.05v-3.31l-2.34-2.34h-3.31l-2.34,2.34v3.31l2.34,2.34h3.31l2.34-2.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPreview);
export default __webpack_public_path__ + "static/1770312069/media/icon-preview.a4e4ceb8e72f92cfcac8186e381a44d9.svg";
export { ForwardRef as ReactComponent };